module.exports = "<angular-tinymce #mce [(ngModel)]='content' [settings]='customSettings'></angular-tinymce>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/editors/tinymce/tinymce.component.html
// module id = ../../../../../src/app/components/editors/tinymce/tinymce.component.html
// module chunks = main